import React from "react";

/**
 * ErrorBoundary — evita la "pantalla en blanco" (white screen) cuando un
 * componente lanza un error en render. Muestra el mensaje del error en el área
 * de contenido para poder diagnosticar, sin tumbar el menú lateral.
 */
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // Log para consola del navegador (útil para soporte/diagnóstico)
    console.error("ErrorBoundary atrapó un error:", error, info);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      const msg = this.state.error?.message || String(this.state.error || "Error desconocido");
      return (
        <div className="p-8" data-testid="error-boundary">
          <div className="max-w-2xl border border-red-300 bg-red-50 rounded-md p-6">
            <h2 className="text-xl font-bold text-red-800">Ocurrió un error al cargar esta pantalla</h2>
            <p className="text-sm text-red-700 mt-2">
              Hemos evitado que la aplicación se quede en blanco. Comparte este detalle con soporte:
            </p>
            <pre className="mt-3 text-xs bg-white border border-red-200 rounded-sm p-3 overflow-auto text-red-900 whitespace-pre-wrap">
              {msg}
            </pre>
            <div className="mt-4 flex gap-3">
              <button
                onClick={this.handleReset}
                className="px-4 py-2 rounded-sm bg-[var(--brand,#E31E24)] text-white text-sm font-semibold hover:bg-[#b81920]"
                data-testid="error-boundary-retry"
              >
                Reintentar
              </button>
              <button
                onClick={() => window.location.assign("/")}
                className="px-4 py-2 rounded-sm border border-slate-300 text-slate-700 text-sm font-semibold hover:bg-slate-50"
              >
                Ir al inicio
              </button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
